<template>
  <div class="anniversary-container swiper">
    <div class="loading-wrapper" v-if="loading">
      <van-loading />
    </div>
    <div class="swiper-wrapper" v-show="!loading">
      <page-start :swiper="swiper" :data="data"></page-start>
      <page-roadmap :swiper="swiper"></page-roadmap>
      <page-meet :swiper="swiper" :data="data"></page-meet>
      <page-contract :swiper="swiper" :data="data" v-if="data && data.amount"></page-contract>
      <page-contract-first :swiper="swiper" :data="data" v-if="data && data.amount && data.firstContractDate"></page-contract-first>
      <page-contract-last :swiper="swiper" :data="data" v-if="data && data.amount && data.yearDiff"></page-contract-last>
      <page-activities :swiper="swiper" :data="data" v-if="data && data.campaignTimes"></page-activities>
      <page-content :swiper="swiper" :data="data" v-if="data && data.registrationDate"></page-content>
      <page-coupon :swiper="swiper" :data="data" v-if="data"></page-coupon>
      <page-key-words :swiper="swiper"></page-key-words>
      <page-key-words-reslut :swiper="swiper"></page-key-words-reslut>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/swiper.min.css'
import PageStart from '../../../components/Anniversary/PageStart/index'
import PageRoadmap from '../../../components/Anniversary/PageRoadmap/index'
import PageMeet from '../../../components/Anniversary/PageMeet/index'
import PageContract from '../../../components/Anniversary/PageContract/index'
import PageContractFirst from '../../../components/Anniversary/PageContractFirst/index'
import PageContractLast from '../../../components/Anniversary/PageContractLast/index'
import PageActivities from '../../../components/Anniversary/PageActivities/index'
import PageCoupon from '../../../components/Anniversary/PageCoupon/index'
import PageContent from '../../../components/Anniversary/PageFinal/index'
import PageKeyWords from '../../../components/Anniversary/PageKeyWords/index.vue'
import PageKeyWordsReslut from '../../../components/Anniversary/PageKeyWordsReslut/index.vue'
import wx from 'wx'

import * as swiperAni from '../../../util/animate'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      swiper: null,
      isWapp: true,
      data: {}
    }
  },
  computed: {
    ...mapGetters([
      'hasLogin'
    ])
  },
  methods: {
    ...mapMutations([
      'toggleCustomerService'
    ]),
    async getAnniversaryDetail () {
      if (this.hasLogin) {
        return await this.gcapi('getAnniversaryEventInfo')
      } else {
        this.$weui.topTips('请您先登录~', 1000)
        wx.miniProgram.navigateTo({
          url: '/pages/login/login?redirectH5PathName=anniversary'
        })
        return false
      }
    }
  },
  components: { PageStart, PageRoadmap, PageMeet, PageContract, PageContractFirst, PageContractLast, PageActivities, PageCoupon, PageContent, PageKeyWords, PageKeyWordsReslut },
  beforeMount () {
    this.toggleCustomerService(true)
  },
  beforeDestroy () {
    this.toggleCustomerService(false)
  },
  async mounted () {
    this.loading = true
    const res = await this.getAnniversaryDetail()
    if (res === false) return
    this.data = res.data.result || {}
    const showRes = await this.gcapi('getIfShowAnniversaryPrize')
    this.data.showPrize = showRes.data.result
    console.log('res:', res.data.result, showRes.data.result)

    this.$nextTick(() => {
      const swiper = new Swiper('.swiper', {
        direction: 'vertical',
        pagination: false,
        on: {
          init: (swiper) => {
            swiperAni.swiperAnimateCache(swiper) // 隐藏动画元素
            swiperAni.swiperAnimate(swiper) // 初始化完成开始动画
          },
          slideChangeTransitionEnd: () => {
            swiperAni.swiperAnimate(swiper) // 每个slide开始切换时也运行当前slide动画
          }
        }
      })

      this.swiper = swiper
    })
    this.loading = false
  }
}
</script>
<style lang="less" scoped>
.anniversary-container {
  width: 100vw;
  height: 100vh;

  .loading-wrapper {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// Anniversary.vue?24631ee5